export enum UsersActionTypes {
  FETCH_AUTH_FRIENDS = "FETCH_AUTH_FRIENDS",
}
